import React from 'react';
import css from './Table.module.scss';
import SortVertical01 from '../Icons/SortVertical01'
import PropTypes from 'prop-types';
import { useTableContext } from './TableContext';

const TableSortableHeader = ({
  width,
  children,
  style,
  sortable,
  onSortColumn,
  index,
  align,
  className = '',
  rowSpan,
  colSpan
}) => {
  const {cellAlign} = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';

  return (
    <th
      className={`${css.th} ${sortable ? css.thSortable : ''} ${className}`.trim()}
      style={{width: width ?? undefined, cursor: sortable ? 'pointer' : 'default', textAlign: finalAlign, ...style}}
      onClick={sortable ? () => onSortColumn(index) : undefined}
      rowSpan={rowSpan}
      colSpan={colSpan}
    >
      {children}
      {sortable && <SortVertical01 />}
    </th>
  );
};

TableSortableHeader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  rowSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sortable: PropTypes.bool,
  onSortColumn: PropTypes.func,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableSortableHeader;
